import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import b from 'b_';

import './publication-item.css';

import { Publication, ResearcherShort } from '@interfaces/publications-page';
import { formatDate } from 'client/helpers/date';
import getFirstPublicationThemeWithImage from 'client/helpers/getFirstPublicationThemeWithImage';

interface Props {
    entity: Publication;
    type: 'horizontal' | 'vertical';
}

const class_ = b.with('publication-item');

export default class PublicationItem extends PureComponent<Props> {
    public get url() {
        const { entity: publication } = this.props;

        return  `/publications/${publication.id}`;
    }

    public shouldComponentUpdate() {
        return true;
    }

    public getResearcherShortName({ firstName, lastName }: Partial<ResearcherShort>) {
        const firstNameLetter = firstName ? `${firstName[0]}. ` : '';

        return `${firstNameLetter}${lastName}`;
    }

    public getImage(publication: Publication) {
        const themeData = getFirstPublicationThemeWithImage(publication);

        return themeData.previewImage || themeData.image;
    }

    public renderImage() {
        const { entity: publication } = this.props;
        const imageUrl = publication.image || this.getImage(publication);

        return (
            <Link
                className={class_('image-wrap')}
                to={this.url}
                style={{ backgroundImage: `url(${imageUrl})` }}
            >
                <img className={class_('image')} src={imageUrl} />
            </Link>
        );
    }

    public renderResearchers(researchers: ResearcherShort[]) {
        return researchers.map(({ id, firstName, lastName }: ResearcherShort) => (
            <span key={id}>
                <Link
                    className={class_('researcher')}
                    to={`/people/${id}`}
                >
                    {this.getResearcherShortName({ firstName, lastName })}
                </Link>
            </span>
        ));
    }

    public render() {
        const { type, entity: publication } = this.props;
        const meta = [
            publication.publicationDate && formatDate(publication.publicationDate, 'y'),
            publication.publicationShortPlace
        ].filter(Boolean).join(', ');

        return (
            <div key={publication.id} className={class_({ pinned: publication.isPinned, type })}>
                {this.renderImage()}

                <div className={class_('content')}>
                    <Link className={class_('title')} to={this.url}>
                        {publication.title}
                    </Link>
                    <div className={class_('researchers')}>
                        {this.renderResearchers(publication.researchers)}
                    </div>
                    <div className={class_('meta')}>
                        {meta}
                    </div>
                </div>
            </div>
        );
    }
}
